/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type { UserOrganisationSystemSettingsDto } from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiUserOrganisationSystemSettingsController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-user-organisation-system-settings-controller
   * @name GetUserOrganisationSystemSettings
   * @request GET:/api/v1/user-organisation-system-settings/{organisationId}/user/{userId}
   */
  getUserOrganisationSystemSettings = (
    organisationId: string,
    userId: string,
    params: RequestParams = {},
  ) =>
    this.http.request<UserOrganisationSystemSettingsDto, any>({
      path: `/v1/user-organisation-system-settings/${organisationId}/user/${userId}`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getUserOrganisationSystemSettingsPath =
    '/v1/user-organisation-system-settings/${organisationId}/user/${userId}'
  static getUserOrganisationSystemSettingsMethod = 'GET'
  /**
   * No description
   *
   * @tags api-user-organisation-system-settings-controller
   * @name UpdateUserOrganisationSystemSettings
   * @request PUT:/api/v1/user-organisation-system-settings/{organisationId}/user/{userId}
   */
  updateUserOrganisationSystemSettings = (
    organisationId: string,
    userId: string,
    data: UserOrganisationSystemSettingsDto,
    params: RequestParams = {},
  ) =>
    this.http.request<UserOrganisationSystemSettingsDto, any>({
      path: `/v1/user-organisation-system-settings/${organisationId}/user/${userId}`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updateUserOrganisationSystemSettingsPath =
    '/v1/user-organisation-system-settings/${organisationId}/user/${userId}'
  static updateUserOrganisationSystemSettingsMethod = 'PUT'
}
